import { connect } from 'react-redux';
import { PhotoCaptureMessage, getPhotoCaptureUnderWritingCompanyName, getPhotoCaptureClaimNumber, getPhotoCaptureAssignmentType, getDynamicRedirectURL, getRedirectMethod, getShopUpdatedValueByUser, getShouldEnableRepairShop, getIsShopSelectionScreenVisited, getHasEstimatorWorkflow, getPhotoCaptureUserVehicleInfo, getPhotoCaptureVehicle } from "../../../domain/photoCapture";
import { getGPCTheme, getAutoRedirectionUrl, getGPCLoadingStatus } from '../selectors';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        underWritingCompanyName: getPhotoCaptureUnderWritingCompanyName(state),
        claimNumber: getPhotoCaptureClaimNumber(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        autoRedirectionUrl: getDynamicRedirectURL(state) || getAutoRedirectionUrl(state),
        isLoading: getGPCLoadingStatus(state),
        redirectionMethod: getRedirectMethod(state),
        isShopUpdatedByUser: getShopUpdatedValueByUser(state),
        isRepairShopEnable: getShouldEnableRepairShop(state),
        isShopSelectionScreenVisited: getIsShopSelectionScreenVisited(state),
        hasEstimatorWorkflow: getHasEstimatorWorkflow(state),
        userVehicleInfo: getPhotoCaptureUserVehicleInfo(state),
        vehicle: getPhotoCaptureVehicle(state)
    };
};
export const ConnectedPhotoCaptureMessage = connect(mapStateToProps)(PhotoCaptureMessage);
//# sourceMappingURL=ConnectedPhotoCaptureMessage.js.map